// extracted by mini-css-extract-plugin
export default {"form-item":"CreateNotificationPopup_form-item__ROFqz"};